import React from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import HospitalIcon from 'assets/images/Dashboard/doctor-hospital.svg';
import VideoCallCameraIcon from 'assets/images/Dashboard/Video_Call.svg';
import moment from 'moment';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import Loader from 'components/commom/Loader';

const DoctorPaietntAppointmentList = () => {
  const loading = useSelector(
    (state) => state?.getPatientDetailReducer?.loading
  );

  const patientDetail = useSelector(
    (state) => state?.getPatientDetailReducer?.users?.data
  );

  return (
    <div>
      <Row className="m-0">
        <Col md={12} className="p-0">
          <div className="pt-24 pb-12 fs-16 lh-16 family_outfit_medium_500 fc-292D32">
            Appointment History
          </div>
        </Col>
        <Col md={12} className="p-0">
          {loading ? (
            <Loader marginTop={'20vh'} />
          ) : patientDetail?.appointment_history &&
            patientDetail?.appointment_history.length > 0 ? (
            <>
              <Row className="listCustomHeader m-0 p-0 flex items-center">
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600">
                    <FormattedMessage id="Booking ID" />
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600">
                    <FormattedMessage id="Modality" />
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600">
                    <FormattedMessage id="Date & Time" />
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600">
                    <FormattedMessage id="Actions" />
                  </p>
                </Col>
              </Row>
              <Row className="bc-FFFFFF m-0 p-0">
                {patientDetail?.appointment_history.map((item, index) => {
                  return (
                    <Row className="m-0 p-0 flex items-center listAppointment">
                      <Col lg={2} md={6} sm={12}>
                        <div className="fs-12 fc-202224 lh-1512 family_outfit_regular_400">
                          {item?.booking_id}
                        </div>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <div className="flex text-center">
                          <Image
                            src={
                              item?.consultation_type === 'Hospital Visit'
                                ? HospitalIcon
                                : VideoCallCameraIcon
                            }
                            alt={'image'}
                          />
                        </div>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <div className="p-0 m-0 fs-14 lh-176 fc-202224 family_outfit_regular_400">
                          {`${moment(item?.appointment_date_time).format('DD MMM YYYY')}, ${moment(
                            item?.appointment_date_time
                          ).format('hh:mmA')}`}
                        </div>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <Stack
                          direction="horizontal"
                          gap={2}
                          className="items-center cursor-pointer"
                        >
                          <div className="fs-14 lh-14 fc-292D32 family_outfit_medium_500">
                            Summary
                          </div>
                          <div className="flex" key={index}>
                            <a
                              href={item?.diagnosis_report || '#'}
                              download={
                                item?.diagnosis_report
                                  ? item?.diagnosis_report.split('/').pop()
                                  : 'license'
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                              className="fs-14 lh-14 fc-292D32 family_outfit_medium_500 cursor-pointer underline underline-offset-4"
                            >
                              {item?.diagnosis_report &&
                                item?.diagnosis_report.split('/').pop()}
                            </a>
                          </div>
                        </Stack>
                      </Col>
                    </Row>
                  );
                })}
              </Row>
            </>
          ) : (
            <div className="flex justify-center pt-120">
              <div>
                <Image src={EmptyScreen} alt="icon" />
                <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                  Nothing here yet
                </div>
                <div className="fs-16 fc-998A7B lh-16 family_outfit_regular_400  text-center pt-8">
                  No appointments have been booked
                </div>
              </div>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DoctorPaietntAppointmentList;
